import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { SubMenuComponent } from './sub-menu.component';

@NgModule({
    imports: [SharedModule],
    declarations: [SubMenuComponent],
    entryComponents: [SubMenuComponent],
    exports: [SubMenuComponent]
})
export class SubMenuModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/sub-menu/sub-menu.module.ts